export const getCategoryLabel = (category) => {
  const labels = {
    admin: '🔐 Admin',
    tool: '🔧 Tools',
    module: '📦 Modules',
    production: '🏭 Production',
  };
  return labels[category] || category;
};

export const getPermissionsByCategory = (permissions = []) =>
  permissions.reduce((acc, perm) => {
    if (!acc[perm.category]) acc[perm.category] = [];
    acc[perm.category].push(perm);
    return acc;
  }, {});

export const generateMessage = (msg, type) => {(
    msg && <div className="message {type}">{msg}</div>
);};
